@if (copy) {
  <div class="trip-upsell-banner" [class.trip-upsell-banner--expired]="isExpired">
    <img
      [src]="copy.globeSrc"
      alt=""
      width="90"
      height="90"
      class="trip-upsell-banner__globe"
      [class.trip-upsell-banner__globe--dimmed]="isExpired"
    />

    <div class="trip-upsell-banner__content">
      @if (!isExpired) {
        <p class="trip-upsell-banner__timer">Available within {{ countdown }}</p>
      }

      <h2 class="trip-upsell-banner__title semi-bold">
        {{ isExpired ? TRIP_UPSELL_BANNER_EXPIRED_COPY.title : copy.title }}
      </h2>

      <p class="trip-upsell-banner__body">
        {{ isExpired ? TRIP_UPSELL_BANNER_EXPIRED_COPY.body : copy.body }}
      </p>
    </div>

    @if (!isExpired) {
      <ds-button
        [routerLink]="['/', PortalRoutes.AncillaryUpsell, tripPortalLink]"
        label="See plans & upgrade"
        class="trip-upsell-banner__cta"
        [fullWidth]="true"
      />
    }
  </div>
}
